import {
    Component,
    OnInit,
    OnChanges,
    OnDestroy,
    SimpleChanges,
    AfterViewInit,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    ElementRef,
    ViewChild
  } from '@angular/core';
  
  declare var $: any;
  
  import {SectionI} from '../types';
  
  import { ToastrService } from 'ngx-toastr';

  import {AppSettings} from '../settings';
  import {CommonService} from '../services/common.service';
  
  @Component({
    selector: 'list-item',
    templateUrl: './list-item.component.html',

  
    encapsulation: ViewEncapsulation.None,
  })
  export class ListItemComponent implements OnInit, AfterViewInit {


    url:any=AppSettings.API_ENDPOINT;

    @Input('detail') detail:any;
    @Input('ind') ind:any;
    @Input('ind2') ind2:any;
    @Input('type')type:any;

    commonService:any;
    
    constructor(private cmmonService:CommonService){

      this.commonService = cmmonService; 
    }

    ngOnInit(){

   

    }


    mouseEnter(ind:any,ind2:any){


    }
    
    toggleWithGreeting(popover) {
      if (popover.isOpen()) {
        popover.close();
      } else {
        popover.open();
      }
    }

    ngAfterViewInit(){

     

  
        var id1:any= '#'+this.ind+'_'+this.ind2;

        $(id1).popover({
                html: true,
                container: 'body',
                trigger: 'hover',
                content: function() {
                   
                
        
                    var id = '#template-details-info_'+$(this).attr('id');
    
                    return $(id).children(".popover-body").html();

                }
            });

            // let val='#template-preview_'+this.ind+'_'+this.ind2
            let card="#card_"+this.ind+'_'+this.ind2
            
            $(card).popover({
              html: true,
              container: 'body',
              trigger: 'hover',
              content: function() {
                  let val = '#template-preview_'+$(this).attr('id');
                  return $(val).children(".popover-body").html();
      
              }
            });   
 


       
 


    }

    ngOnChanges(changes: SimpleChanges): void {
          
     

        this.ind2 = (changes.ind2!=undefined)?changes.ind2.currentValue:this.ind2;

        this.ind = (changes.ind!=undefined)?changes.ind.currentValue:this.ind;
 

      

        
    }

  }
